import { Step } from "components/types";
import { getQuestionnaire } from "api/apiService";
import { buildQuestionnaire } from "@modules/questionnaire-builder";
import { STORAGE_KEY } from "@modules/questionnaire-builder/constants";
import { ReportType } from "@modules/questionnaire-builder/ReportType";
import { Questionnaire } from "@modules/fhirQuestionnaire/Questionnaire";
import { getQuestionnaireStorageKey } from "components/Form/Form.helpers";
import allPossibleSectionsConfig from "@modules/questionnaire-builder/allPossibleSectionsInQuestionnaireShape.json";

const allPossibleSectionsInQuestionnaireShape =
  allPossibleSectionsConfig as unknown as Questionnaire;

function getOrBuildQuestionnaire(type: ReportType, storageKey: string) {
  const storedQuestionnaire = localStorage.getItem(storageKey);

  if (
    !storedQuestionnaire ||
    JSON.parse(storedQuestionnaire).version !==
      allPossibleSectionsInQuestionnaireShape.version
  ) {
    const questionnaire = buildQuestionnaire(
      type,
      allPossibleSectionsInQuestionnaireShape,
    );

    localStorage.setItem(storageKey, JSON.stringify(questionnaire));
    return questionnaire;
  }

  return JSON.parse(storedQuestionnaire!);
}

getOrBuildQuestionnaire(ReportType.INITIAL, STORAGE_KEY.QUESTIONNAIRE.INITIAL);
getOrBuildQuestionnaire(
  ReportType.FOLLOW_UP,
  STORAGE_KEY.QUESTIONNAIRE.FOLLOW_UP,
);
getOrBuildQuestionnaire(
  ReportType.INITIAL_ORTHO_EXTREMITIES,
  STORAGE_KEY.QUESTIONNAIRE.INITIAL_ORTHO_EXTREMITIES,
);
getOrBuildQuestionnaire(
  ReportType.FOLLOW_UP_ORTHO_EXTREMITIES,
  STORAGE_KEY.QUESTIONNAIRE.FOLLOW_UP_ORTHO_EXTREMITIES,
);

export async function resolveQuestionnaire(
  step: Step,
  contractType: ReportType,
) {
  if (step === Step.QUESTIONNAIRE_FORM) {
    const storageKey = getQuestionnaireStorageKey(contractType);
    return getOrBuildQuestionnaire(contractType, storageKey);
  }

  return await getQuestionnaire(step);
}
